import moment from 'moment';
import store from '../../store';

export const checkValidEmail = (emailId) => {

  var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

  return (pattern.test(emailId)) ? true : false;

}

export const checkValidPasswpord = (password) => {
  return (password.match(/[a-z]/g) && password.match(
    /[A-Z]/g) && password.match(
      /[0-9]/g) && password.match(
        /[^a-zA-Z\d]/g) && password.length >= 8 && password.length > 7 && password.length < 16) ? true : false;

}

export const getLoginToken = () => {
  const userToken = localStorage.getItem("user-token");
  return userToken;
}

export const getApiUrl = () => {
  return process.env.REACT_APP_API_URL;
}

export const dateFormat = (date) => {
  return moment(date).format('MM/DD/YYYY');
}

export const dbDateFormat = (date) => {
  if (!date) {
    return null;
  }

  const momentDate = moment(date);
  if (!momentDate.isValid()) {
    return null;
  }

  const formattedDate = momentDate.utc().toISOString();
  return formattedDate;
}

export const getExtension = (filename) => {
  var parts = filename.split('.');
  return parts[parts.length - 1];
}

export const isImage = (filename) => {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
      //etc
      return true;
  }
  return false;
}

export const isValidDocument = (filename) => {
  const ext = getExtension(filename);
  const fileTypeArr = ["jpeg", "jpg", "png", "pdf", "doc", "docx", "odt", "xls", "xlsx", "ods", "dwg", "dwf", "xml", "nc1", "dxf"];
  return fileTypeArr.includes(ext.toLowerCase());

}

export const checkImageSize = (size) => {

  let file = Math.round((size / 1024));

  if (file <= 5120) {
    return true;
  }
  return false;
}

export const checkDrawingFileSize = (size) => {

  let file = Math.round((size / 1024));

  if (file <= 409600) {
    return true;
  }
  return false;
}

export const convertToGmt = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
}

export const dbDateFormatWithTime = (date) => {
  return moment(date).toISOString();
}

export const formateDateToShow = (date) => {
  return moment(date).add(1, 'day').format('MM/DD/YYYY');
}

export const hasOnlyWhiteSpaces = (str) => {
  if (!str.replace(/\s/g, '').length) {
    return true
  }
  return false;
}

export const getRoleKey = () => {
  console.log({ helperData: store.getState().loginUserData });
  const roleKey = localStorage.getItem("roleKey");
  return roleKey;
}

export const validDocumentArr = () => {
  return [".jpeg", ".jpg", ".png", ".pdf", ".doc", ".docx", ".odt", ".xls", ".xlsx", ".ods", ".dwg", ".dwf", ".xml", ".nc1", ".dxf"];
}

export const validDocumentMimeTypes = () => {
  return {
    'image/*': ['.jpeg', '.jpg', '.png'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.oasis.opendocument.text': ['.odt'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
    'application/octet-stream': ['.dwg', '.dwf', '.nc1', '.dxf'],
    'application/xml': ['.xml']
  };
}
